






import Vue from "vue";

export default Vue.extend({
  props: {
    label: {
      type: String,
      default: "Choose file"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String
    }
  }
});
